// this module will return the current data and time
// if time is set to true time will also appear with date
module.exports = function(time, year) {
  var now     = new Date(),
    year      = now.getFullYear(),
    month     = now.getMonth()+1,
    day       = now.getDate(),
    hour      = now.getHours(),
    minute    = now.getMinutes(),
    second    = now.getSeconds(),
    dateTime = '';
  
  // create date and time output
  if(month.toString().length === 1) {
    month = '0' + month;
  }
  if(day.toString().length === 1) {
    day = '0' + day;
  }   
  if(hour.toString().length === 1) {
    hour = '0' + hour;
  }
  if(minute.toString().length === 1) {
    minute = '0' + minute;
  }
  if(second.toString().length === 1) {
    second = '0' + second;
  }
  // format current date   
  

  // if time is true include current time
  if(time === true){
    dateTime += ' ' + hour + ':' + minute + ':' + second;
  }else if(year === true){
    dateTime += year;
  }else{
    dateTime += day + '/' + month + '/' + year;
  }
  // return the current date/time
  return dateTime;
};